'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('admin-dashboard', {
      url: '/admin/dashboard',
      template: '<admin-dashboard></admin-dashboard>',
      authenticate: 'admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/admin/dashboard/admin-dashboard.routes.js